"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PassengerTypeArray = exports.PassengerType = void 0;
/* eslint-disable guard-for-in, no-restricted-syntax */
var PassengerType;
(function (PassengerType) {
    PassengerType["Lead"] = "lead";
    PassengerType["Child"] = "child";
    PassengerType["Adult"] = "adult";
})(PassengerType || (exports.PassengerType = PassengerType = {}));
exports.PassengerTypeArray = Object.values(PassengerType);
//# sourceMappingURL=PassengerType.js.map